import { ItemKey } from "~/sharedComponents/list";
import { OptionType } from "../../sharedComponents/checkbox";

export const getItemValue = (item: OptionType): ItemKey => item.customItemValue ?? item.id;
